import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3cfd8696")

_pushScopeId("data-v-3cfd8696")
const _hoisted_1 = { class: "very-low" }
const _hoisted_2 = { class: "low" }
const _hoisted_3 = { class: "medium" }
const _hoisted_4 = { class: "high" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "high" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("table", null, [
    _createVNode("thead", null, [
      _createVNode("tr", null, [
        _createVNode("td", null, _toDisplayString($setup.t('Simulation.person')), 1),
        _createVNode("td", _hoisted_1, _toDisplayString($setup.t(`Simulation.TaxBracket.${$setup.TaxBracket.VERY_LOW}`)), 1),
        _createVNode("td", _hoisted_2, _toDisplayString($setup.t(`Simulation.TaxBracket.${$setup.TaxBracket.LOW}`)), 1),
        _createVNode("td", _hoisted_3, _toDisplayString($setup.t(`Simulation.TaxBracket.${$setup.TaxBracket.MEDIUM}`)), 1),
        _createVNode("td", _hoisted_4, _toDisplayString($setup.t(`Simulation.TaxBracket.${$setup.TaxBracket.HIGH}`)), 1)
      ])
    ]),
    _createVNode("tbody", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.plafonds, (plafond, index) => {
        return (_openBlock(), _createBlock("tr", { key: plafond }, [
          _createVNode("td", null, _toDisplayString($setup.getHeader(index)), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(plafond, (price, i) => {
            return (_openBlock(), _createBlock("td", {
              key: price,
              class: {
            'very-low': i === 0,
            low: i === 1,
            medium: i === 2,
          }
            }, [
              (index !== 5)
                ? (_openBlock(), _createBlock("span", _hoisted_5, " jusqu'à " + _toDisplayString($setup.formatEuro(price, 0)), 1))
                : _createCommentVNode("", true),
              (index === 5)
                ? (_openBlock(), _createBlock("span", _hoisted_6, " + " + _toDisplayString($setup.formatEuro(price, 0)), 1))
                : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _createVNode("td", _hoisted_7, [
            (index !== 5)
              ? (_openBlock(), _createBlock("span", _hoisted_8, " > " + _toDisplayString($setup.formatEuro(plafond[2], 0)), 1))
              : _createCommentVNode("", true),
            (index === 5)
              ? (_openBlock(), _createBlock("span", _hoisted_9, " + " + _toDisplayString($setup.formatEuro(plafond[2], 0)), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
})